import React, { useEffect, useState } from 'react';
import './OurTeam.css';
import { supabase } from "../supabaseClient";

const OurTeam = () => {
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    const getTeam = async () => {
      const res = await supabase.from("AboutFour").select("*");
      setTeamMembers(res.data);
    };
    getTeam();
  }, []);

  return (
    <section className="our-team-section">
      <div className="team-grid">
        {teamMembers.map((member) => (
          <div key={member.id} className="team-card">
            <div className="image-container">
              <img src={member.image_url} alt={member.name} />
            </div>
            <div className="member-details">
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurTeam;